import { FORM_SUBMISSION_MEMORY_NAMESPACE, FORM_SUBMISSION_MEMORY_STORAGE_FORMAT_VERSION } from "./constants";
import type { FormSubmissionMemoryIdentity, FormSubmissionMemoryRuntimeContext } from "./types";

function normalizeScope(scope: FormSubmissionMemoryIdentity["scope"]): string | null {
    if (scope == null) {
        return null;
    }

    const normalized = String(scope).trim();
    return normalized.length > 0 ? normalized : null;
}

function normalizeLogicalKey(key: string): string | null {
    const normalized = key.trim();
    return normalized.length > 0 ? normalized : null;
}

/**
 * Строит physical key для `localStorage` из runtime context и логической identity.
 *
 * @param identity логический ключ, scope и schemaVersion записи
 * @param runtime server URL и user code
 * @returns physical key или `null`, если persist недоступен
 */
export function buildFormSubmissionMemoryStorageKey(
    identity: FormSubmissionMemoryIdentity,
    runtime: FormSubmissionMemoryRuntimeContext,
): string | null {
    const logicalKey = normalizeLogicalKey(identity.key);
    const serverUrl = runtime.serverUrl?.trim();
    const userCode = runtime.userCode;

    if (logicalKey == null || serverUrl == null || serverUrl.length === 0 || userCode == null) {
        return null;
    }

    const scopePart = normalizeScope(identity.scope);
    const base = [
        FORM_SUBMISSION_MEMORY_NAMESPACE,
        `v${FORM_SUBMISSION_MEMORY_STORAGE_FORMAT_VERSION}`,
        serverUrl,
        String(userCode),
        logicalKey,
    ];

    if (scopePart != null) {
        base.push(scopePart);
    }

    return base.join(":");
}
